import help from '@/page/help/help'

const helpRouter = [{
  path: '/help',
  name: 'help',
  component: help
}]

export default helpRouter


// WEBPACK FOOTER //
// ./src/router/help.js